import { BaseModel } from '../base-model.model';
import { PWUtils } from '../../shared/pw-utils';

export class AuthenticatedUser extends BaseModel {
  phoneNumber: string;
  userName: string;
  email: string;
  name: string;
  role: any;
  rolePermission: number;
  group: string;
  password: string;
  confirmPassword: string;
  token: string;
  photoPath?: string;
  rememberMe: boolean;

  public get isConfirmPasswordMatch(): boolean {
    return PWUtils.isNotEmpty(this.password) && this.password === this.confirmPassword;
  }
}
